<template>
  <section
    :class="[
      'section3',
      (current_match && current_match.status) !== 1 ? 'btn-disabled' : '',
    ]"
  >
    <div class="filter-and-results">
      <div v-bind:class="['contest-result']">
        <span
          class="count"
          v-if="
            current_match &&
            current_match.isLoaded &&
            selected_match_contests.length
          "
        >
          {{ selected_match_contests.length ? contest_count : translations.no }}
          {{ translations.contests_found }}
        </span>
        <span
          class="result-text"
          v-if="
            current_match &&
            current_match.isLoaded &&
            selected_match_contests.length
          "
          >{{ translations.sorted_by }}: {{ getAppliedSortingOrder() }}</span
        >
      </div>
      <!-- filter section start -->
      <div class="more-filter" v-if="(current_match && current_match.status) === 1">
        <div
          v-bind:class="[
            'filter-head',
            filters.filter_applied || true ? 'active' : '',
          ]"
          @click.stop="openFilterSection"
        >
          <span class="icon-filter"></span>
          <span class="filter-txt">{{ translations.sort_filter_label }}</span>
        </div>
        <div class="filter-body" v-if="showFilterPopUp">
          <div class="filter-tab-content">
            <div class="filter-wrap">
              <div class="head">
                <span>{{ translations.sort_filter_label }}</span>
                <button
                  class="btn reset"
                  type="button"
                  @click.stop="resetFilter(true)"
                >
                  {{ translations.reset }}
                </button>
              </div>
              <div class="body">
                <div class="content-wrapper">
                  <!--
                    control tabs
                  -->
                  <div class="tab-section">
                    <ul>
                      <li
                        v-bind:class="[
                          'sub-filter',
                          filterElemsConfig.sort ? 'active' : '',
                        ]"
                        @click.stop="
                          (filterElemsConfig.sort = true),
                            (filterElemsConfig.ef = false),
                            (filterElemsConfig.ppool = false),
                            (filterElemsConfig.platform = false),
                            (filterElemsConfig.spots = false)
                        "
                      >
                        {{ translations.sort_by }}
                      </li>
                      <li
                        v-bind:class="[
                          'sub-filter',
                          filterElemsConfig.ppool ? 'active' : '',
                        ]"
                        @click.stop="
                          (filterElemsConfig.sort = false),
                            (filterElemsConfig.ef = false),
                            (filterElemsConfig.ppool = true),
                            (filterElemsConfig.platform = false),
                            (filterElemsConfig.spots = false)
                        "
                      >
                        {{ translations.prize_pool }}
                      </li>

                      <li
                        v-bind:class="[
                          'sub-filter',
                          filterElemsConfig.spots ? 'active' : '',
                        ]"
                        @click.stop="
                          (filterElemsConfig.sort = false),
                            (filterElemsConfig.ef = false),
                            (filterElemsConfig.ppool = false),
                            (filterElemsConfig.platform = false),
                            (filterElemsConfig.spots = true)
                        "
                      >
                        {{ translations.spots_label }}
                      </li>
                      <li
                        v-bind:class="[
                          'sub-filter',
                          filterElemsConfig.platform ? 'active' : '',
                        ]"
                        @click.stop="
                          (filterElemsConfig.sort = false),
                            (filterElemsConfig.ef = false),
                            (filterElemsConfig.ppool = false),
                            (filterElemsConfig.platform = true),
                            (filterElemsConfig.spots = false)
                        "
                      >
                        {{ translations.platform }}
                      </li>
                    </ul>
                  </div>
                  <div class="sub-filter-section">
                    <!--
                      sorting section
                    -->
                    <section
                      class="extended-section sort-section"
                      v-if="filterElemsConfig.sort"
                    >
                      <div class="sort-tab-content">
                        <div class="body">
                          <ul>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'ar' &&
                                sort_by.order === 'desc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="applySort({ prop: 'ar', order: 'desc' })"
                            >
                              {{ translations.aret_h_l }}
                            </li>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'roip' &&
                                sort_by.order === 'desc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="
                                applySort({ prop: 'roip', order: 'desc' })
                              "
                            >
                              {{ translations.aretper_h_l }}
                            </li>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'mp' &&
                                sort_by.order === 'desc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="applySort({ prop: 'mp', order: 'desc' })"
                            >
                              {{ translations.aprof_h_l }}
                            </li>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'tp' &&
                                sort_by.order === 'desc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="applySort({ prop: 'tp', order: 'desc' })"
                            >
                              {{ translations.price_h_l }}
                            </li>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'ef' &&
                                sort_by.order === 'desc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="applySort({ prop: 'ef', order: 'desc' })"
                            >
                              {{ translations.entry_h_l }}
                            </li>
                            <li
                              v-bind:class="[
                                'sorting-list',
                                sort_by.prop === 'ef' && sort_by.order === 'asc'
                                  ? 'active'
                                  : '',
                              ]"
                              @click="applySort({ prop: 'ef', order: 'asc' })"
                            >
                              {{ translations.entry_l_h }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </section>
                    <!--
                      price filter section
                    -->
                    <section
                      class="extended-section prize-section"
                      v-if="filterElemsConfig.ppool"
                    >
                      <div class="tag">
                        <span class="label">{{
                          translations.select_entry_range
                        }}</span>
                        <form class="range-form" @submit.prevent>
                          <div class="form-group min-range">
                            <input
                              :value="price_range_l"
                              v-on:input="price_range_l = +$event.target.value"
                              @keydown="
                                (e) =>
                                  invalidChars.includes(e.key) &&
                                  e.preventDefault()
                              "
                              type="number"
                              name="pricerage"
                              :min="filter_options.total_price_slider[0]"
                              :max="filter_options.total_price_slider[1]"
                              class="form-control"
                              pattern="\d*"
                            />
                          </div>
                          <div class="form-group max-range">
                            <input
                              v-bind:value="price_range_h"
                              v-on:input="price_range_h = +$event.target.value"
                              @keydown="
                                (e) =>
                                  invalidChars.includes(e.key) &&
                                  e.preventDefault()
                              "
                              type="number"
                              name="pricerage"
                              class="form-control"
                              :min="filter_options.total_price_slider[0]"
                              :max="filter_options.total_price_slider[1]"
                              pattern="\d*"
                            />
                          </div>
                        </form>
                      </div>
                      <div class="slidecontainer">
                        <label class="price-range-max price-range">{{
                          translations.max
                        }}</label>
                        <vue-slider
                          v-model="priceRange"
                          v-bind="priceRangeOptions"
                          :tooltip-formatter="formatter"
                          direction="btt"
                          style="margin: 0 auto; height: 150px"
                        ></vue-slider>
                        <label class="price-range-min price-range">{{
                          translations.min
                        }}</label>
                      </div>
                    </section>
                    <!--
                      spots filter section
                    -->
                    <section
                      class="extended-section prize-section"
                      v-if="filterElemsConfig.spots"
                    >
                      <div class="tag">
                        <span class="label">{{
                          translations.select_spot_range
                        }}</span>
                        <form class="range-form" @submit.prevent>
                          <div class="form-group min-range spot-range">
                            <input
                              :value="spots_range_l"
                              v-on:input="spots_range_l = +$event.target.value"
                              @keydown="
                                (e) =>
                                  invalidChars.includes(e.key) &&
                                  e.preventDefault()
                              "
                              type="number"
                              name="pricerage"
                              :min="filter_options.total_spots_slider[0]"
                              :max="filter_options.total_spots_slider[1]"
                              class="form-control"
                              pattern="\d*"
                            />
                          </div>
                          <div class="form-group max-range spot-range">
                            <input
                              v-bind:value="spots_range_h"
                              v-on:input="spots_range_h = +$event.target.value"
                              @keydown="
                                (e) =>
                                  invalidChars.includes(e.key) &&
                                  e.preventDefault()
                              "
                              type="number"
                              name="pricerage"
                              class="form-control"
                              :min="filter_options.total_spots_slider[0]"
                              :max="filter_options.total_spots_slider[1]"
                              pattern="\d*"
                            />
                          </div>
                        </form>
                      </div>
                      <div class="slidecontainer">
                        <label class="price-range-max price-range">{{
                          translations.max
                        }}</label>
                        <vue-slider
                          v-model="spotsRange"
                          v-bind="spotsRangeOptions"
                          direction="btt"
                          style="margin: 0 auto; height: 150px"
                        ></vue-slider>
                        <label class="price-range-min price-range">{{
                          translations.min
                        }}</label>
                      </div>
                    </section>
                    <!--
                      platform filter section
                    -->
                    <section
                      class="extended-section platform-section"
                      v-if="filterElemsConfig.platform"
                    >
                      <form class="icon-search" @submit.prevent>
                        <input
                          type="search"
                          v-bind:value="platform_search"
                          v-on:input="platform_search = $event.target.value"
                          class="form-control"
                        />
                      </form>
                      <div
                        class="platform-check"
                        v-for="platform in platforms"
                        v-bind:key="platform.pid"
                      >
                        <label class="check-container">
                          {{ platform.pn }}
                          <div class="checkbox-wrap">
                            <input
                              v-model="selected_platforms"
                              type="checkbox"
                              name="radio"
                              v-bind:value="platform.pid"
                              :checked="false"
                            />
                            <span class="checkmark"></span>
                          </div>
                        </label>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
              <div class="footer">
                <button
                  class="close btn"
                  type="button"
                  @click="showFilterPopUp = false"
                >
                  {{ translations.close }}
                </button>
                <button
                  class="save btn active"
                  type="button"
                  @click="applyFilter"
                >
                  {{ translations.save }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- filter section end -->
    </div>

    <!-- no contest found section -->
    <div
      class="no-contest-section"
      v-if="
        current_match &&
        current_match.isLoaded &&
        !is_contest_loading &&
        !selected_match_contests.length
      "
    >
      <div class="no-contest-thumbnail">
        <img src="/static-assets/images/cssimages/no-contest-cham.png" alt="" />
      </div>
      <div class="no-contest-text">
        <p class="text">{{ translations.no_contests_found }}</p>
      </div>
    </div>
    <!-- contest list area -->
    <!-- <gamezy-ad size="mob_small" ad_id="mob_small-ad-2" :autoDetect="true" /> -->
    <!-- <gamezy-ad size="web_small" ad_id="web_small-ad-2" :autoDetect="true" /> -->
    <div
      class="contest-list"
      style="height: auto"
      v-if="current_match && current_match.isLoaded && !is_contest_loading"
    >
      <virtual-list :size="size" :remain="remain" :pagemode="true">
        <list-item
          v-for="contest_details of contest_list"
          :key="contest_details.cid"
          :contest_details="contest_details"
          :current_match="current_match"
        />
      </virtual-list>
    </div>
    <!-- contest list area end-->
    <!-- dummy list for shimmer -->
    <div class="contest-list" v-else>
      <div
        class="contest-item img-1by1"
        v-for="i in [1, 2, 3, 4, 5]"
        v-bind:key="i"
      >
        <div class="contest-thumbnail isempty">
          <div class="img-box">
            <img
              src="/static-assets/images/cssimages/default-lazy.png"
              alt=""
              class="lazy"
            />
          </div>
        </div>
        <div class="contest-info">
          <div class="info-wrap">
            <div class="info-section1">
              <div class="info-section-wrap">
                <div class="name isempty"></div>
                <div class="price-detail isempty">
                  <span class="entry-fee"></span>
                  <span class="spot"></span>
                </div>
              </div>
              <div class="contest-rating isempty">
                <span class="profit"></span>
                <span class="rating"></span>
              </div>
            </div>
            <div class="info-section2">
              <span class="prize-pool isempty"></span>
              <span class="winning isempty"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import listItem from "./ListItem";
import virtualList from "vue-virtual-scroll-list";
// import GamezyAd from '../../common/GamezyAd';
import {
  getMatch,
  applySort,
  addPagePropertiesToObject,
  sendTrackingData,
  convertNumber,
  deepClone,
  mobilecheck,
} from "../../../assets/js/common";
import { CFG_TRACKING, CFG_AD_BANNER_LIST } from "../../../assets/js/config";
import VueSlider from "vue-slider-component/dist-css/vue-slider-component.umd.min";
import "vue-slider-component/dist-css/vue-slider-component.css";
import "vue-slider-component/theme/default.css";

export default {
  props: ["selected_match_contests", "checkIfTourIsActive"],
  data() {
    return {
      remain: 7,
      start: 0,
      size: 80,
      item: listItem,
      itemCount: this.selected_match_contests.length,
      showFilterPopUp: false,
      /**
       * main models for ranges
       */
      priceRange: [0, 0],
      entryFeeRange: [0, 0],
      spotsRange: [0, 0],
      platforms: [],
      selected_platforms: [],
      /**
       * options for slider
       */
      priceRangeOptions: {
        min: 0,
        max: 0,
        enableCross: false,
        silent: true,
      },
      entryFeeRangeOptions: {
        min: 0,
        max: 0,
        enableCross: false,
        silent: true,
      },
      spotsRangeOptions: {
        min: 0,
        max: 0,
        enableCross: false,
        silent: true,
      },
      /**
       * to control view of filter
       */
      filterElemsConfig: {
        sort: true,
        ef: false,
        ppool: false,
        spots: false,
        platform: false,
      },
      platform_search: "",
      sort_by: {
        props: null,
        order: null,
      },
      /**
       * to set lower and higher ranges
       */
      price_range_l: null,
      price_range_h: null,
      entry_range_l: null,
      entry_range_h: null,
      spots_range_l: null,
      spots_range_h: null,
      /**
       * for number input
       */
      invalidChars: ["e", "E", "+", "-", "."],
      /**
       * to display the current sort
       */
      sorting_order: ["ar", "desc"],

      contest_list: this.selected_match_contests,
      insert_ad_tm: null,
    };
  },
  computed: {
    /**shared state */
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug);
    },
    translations() {
      return this.$store.state.translations;
    },
    /**shared state end */
    filter_options() {
      return this.$store.state.contest_store.filter_options;
    },
    filters() {
      return this.$store.state.contest_store.filters;
    },
    reset_scroll() {
      return this.$store.state.contest_store.reset_scroll;
    },
    is_contest_loading() {
      return this.$store.state.contest_store.isLoading;
    },
    contest_count() {
      return this.$store.state.contest_store.contest_count;
    },
  },
  components: {
    "list-item": listItem,
    "virtual-list": virtualList,
    VueSlider,
    // GamezyAd,
  },
  mounted() {
    this.loadFilterOptions();
  },
  methods: {
    applySort(sort_by) {
      this.sort_by = sort_by;
    },
    loadFilterOptions() {
      let [pMin, pMax] = this.filter_options.total_price_slider;

      let [sMin, sMax] = this.filter_options.total_spots_slider;

      if (this.filters.filter_applied) {
        [this.price_range_l, this.price_range_h] = this.filters.price_pool;
        [this.spots_range_l, this.spots_range_h] = this.filters.spots;

        this.priceRange = [this.price_range_l, this.price_range_h];
        this.selected_platforms = this.filters.platforms;
        this.sort_by = this.filters.sort_by;
        this.sorting_order = [this.sort_by.prop, this.sort_by.order];
      } else {
        this.price_range_h = pMax;
        this.price_range_l = pMin;

        this.spots_range_l = sMin;
        this.spots_range_h = sMax;

        this.priceRange = [pMin, pMax];
        this.spotsRange = [sMin, sMax];
        this.selected_platforms = [];
        this.sort_by = {
          prop: "ar",
          order: "desc",
        };
      }
      this.priceRangeOptions.min = pMin;
      this.priceRangeOptions.max = pMax;

      this.spotsRangeOptions.min = sMin;
      this.spotsRangeOptions.max = sMax;

      this.platforms = applySort(this.filter_options.platforms, "pn", "asc");
    },
    applyFilter() {
      let toSend = {
        price_pool: this.priceRange,
        spots: this.spotsRange,
        platforms: this.selected_platforms,
        filter_applied: true,
        sort_by: this.sort_by,
      };
      this.showFilterPopUp = false;
      this.platform_search = "";
      this.sort_by.prop !== null &&
        this.sort_by.order !== null &&
        (this.sorting_order = [this.sort_by.prop, this.sort_by.order]);
      this.$store.dispatch("contest_store/applyFilter", toSend);

      let toTrack = CFG_TRACKING["3"];
      toTrack.label = "Filter applied";
      toTrack.value = JSON.stringify(toSend);
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    resetFilter(canTrack) {
      let toSend = {
        price_pool: [0, 0],
        spots: [0, 0],
        platforms: [],
        filter_applied: false,
        sort_by: {
          prop: "ar",
          order: "desc",
        },
      };
      this.showFilterPopUp = false;
      this.platform_search = "";
      this.sorting_order = ["ar", "desc"];
      this.$store.dispatch("contest_store/applyFilter", toSend);

      if (canTrack) {
        let toTrack = CFG_TRACKING["3"];
        toTrack.label = "Reset filter";
        toTrack.value = "";
        toTrack = addPagePropertiesToObject(toTrack);
        sendTrackingData(toTrack);
      }
    },
    formatter(val) {
      return this.translations.currency_symbol + convertNumber(val);
    },
    onClick(event) {
      if (!event.target.closest(".filter-body")) {
        event.preventDefault();
        event.stopPropagation();
        this.showFilterPopUp = false;
      }
      return false;
    },
    openFilterSection() {
      if (!this.checkIfTourIsActive()) {
        this.showFilterPopUp = !this.showFilterPopUp;
      }
    },
    getAppliedSortingOrder() {
      let key_to_label = {
        desc: {
          ar: this.translations.aret_h_l,
          roip: this.translations.aretper_h_l,
          ef: this.translations.entry_h_l,
          tp: this.translations.price_h_l,
          mp: this.translations.aprof_h_l,
        },
        asc: {
          ef: this.translations.entry_l_h,
        },
      };
      if (this.sorting_order[1] && this.sorting_order[0]) {
        return key_to_label[this.sorting_order[1].toLowerCase()][
          this.sorting_order[0]
        ];
      } else {
        return key_to_label["desc"]["ar"];
      }
    },
    insertAds() {
      let contest_list = deepClone(this.contest_list);

      CFG_AD_BANNER_LIST.forEach((ad) => {
        let ad_obj = {
          is_ad: true,
          cid: ad.id,
        };
        contest_list.splice(ad.place_ad_at, 0, { ...ad_obj, ...ad });
      });
      return contest_list;
    },
  },
  watch: {
    reset_scroll: function () {
      this.showFilterPopUp = false;
    },
    showFilterPopUp: function (isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.onClick);
        if (mobilecheck()) {
          document.body.classList.add("no-scroll");
        }
      } else {
        document.body.classList.remove("no-scroll");
        document.removeEventListener("click", this.onClick);
      }
    },
    filter_options: function (options) {
      this.loadFilterOptions();
      this.showFilterPopUp = false;
    },
    platform_search: function (pfname) {
      if (pfname === "")
        return (this.platforms = [...this.filter_options.platforms]);
      this.platforms = [...this.filter_options.platforms].filter((p) => {
        return p.pn.toLowerCase().includes(pfname.trim().toLowerCase());
      });
    },
    /**
     * if slider or via input is range is  moved min / max
     * then set value for main range model ie priceRange , entryRange etc
     * set price range
     */
    price_range_l: function (range) {
      this.priceRange = [range, this.priceRange[1]];
    },
    price_range_h: function (range) {
      this.priceRange = [this.priceRange[0], range];
    },
    priceRange: function (val) {
      [this.price_range_l, this.price_range_h] = val;
    },
    /**
     * set spot range
     */
    spots_range_l: function (range) {
      this.spotsRange = [range, this.spotsRange[1]];
    },
    spots_range_h: function (range) {
      this.spotsRange = [this.spotsRange[0], range];
    },
    spotsRange: function (val) {
      [this.spots_range_l, this.spots_range_h] = val;
    },
    selected_match_contests: function (list) {
      clearTimeout(this.insert_ad_tm);
      if (typeof list !== "undefined" && list.length) {
        this.contest_list = list;
        this.insert_ad_tm = setTimeout(() => {
          this.contest_list = this.insertAds();
        }, 500);
      } else {
        this.contest_list = [];
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.insert_ad_tm);
  },
};
</script>
